import { DIRETORIA_MODULE_TITLE } from '@/data/diretoriaConstants';

export interface RiqueRouteContext {
  pageContext: string;
  suggestions: string[];
  companyIdFromUrl?: string;
}

const DEFAULT_SUGGESTIONS = [
  'Qual o valor em carteira hoje?',
  'Como está a inadimplência?',
  'Resumo dos kanbans de cobrança',
  'Performance dos operadores no mês',
];

export function resolveRiqueRouteContext(pathname: string, search: string): RiqueRouteContext {
  const params = new URLSearchParams(search);
  const companyIdFromUrl = params.get('companyId') ?? params.get('company') ?? undefined;

  if (pathname.startsWith('/diretoria')) {
    const dataFrom = params.get('dataFrom') ?? undefined;
    const dataTo = params.get('dataTo') ?? undefined;
    const compareFrom = params.get('compareFrom') ?? undefined;
    const compareTo = params.get('compareTo') ?? undefined;
    const periodHint =
      dataFrom && dataTo
        ? ` Período A: ${dataFrom} a ${dataTo}.${compareFrom && compareTo ? ` Período B (comparativo): ${compareFrom} a ${compareTo}.` : ''}`
        : '';
    return {
      pageContext: `Usuário na ${DIRETORIA_MODULE_TITLE} (Faturamento/inadimplência/multas via PortalFly títulos; frota/custo ainda ERP FlyStart; Projeções de locações). Dois períodos editáveis: A (principal) e B (comparativo). Para projetar locações/metas, use get_diretoria_projecao_contexto. Priorize indicadores executivos e deltas vs período B.${periodHint}`,
      suggestions: [
        'Projetar locações do período atual',
        'Como está o gap vs meta de locações?',
        'Como está o faturamento do mês?',
        'Quantas motos disponíveis?',
        'Como está a inadimplência no ERP?',
        'Resuma os KPIs da Diretoria',
      ],
      companyIdFromUrl,
    };
  }

  if (pathname.startsWith('/kanban')) {
    return {
      pageContext: 'Usuário no Kanban de cobrança. Foque em etapas, volumes e títulos vencidos.',
      suggestions: [
        'Resumo dos kanbans de cobrança',
        'Quais etapas têm mais títulos vencidos?',
        'Top clientes em aging 7+ dias',
      ],
      companyIdFromUrl,
    };
  }

  if (pathname.startsWith('/titulos')) {
    return {
      pageContext: 'Usuário na listagem de Títulos. Ajude com aging, clientes e valores em aberto.',
      suggestions: [
        'Qual o valor em carteira hoje?',
        'Top clientes com aging acima de 7 dias',
        'Buscar situação de um cliente por nome',
      ],
      companyIdFromUrl,
    };
  }

  if (pathname.includes('whatsapp')) {
    return {
      pageContext: 'Usuário em relatório/módulo WhatsApp. Foque em mensagens, falhas e cobranças por operador.',
      suggestions: [
        'Quantas cobranças WhatsApp saíram esta semana?',
        'Taxa de falha de mensagens hoje',
        'Performance dos operadores no WhatsApp',
      ],
      companyIdFromUrl,
    };
  }

  if (pathname.startsWith('/operador-performance')) {
    return {
      pageContext: 'Usuário no relatório de desempenho do operador.',
      suggestions: [
        'Quem recuperou mais valor no mês?',
        'Compare taxa de sucesso dos operadores',
        'Resumo de cobrança da equipe',
      ],
      companyIdFromUrl,
    };
  }

  if (pathname.startsWith('/portal')) {
    return {
      pageContext: 'Usuário no Portal central do ecossistema.',
      suggestions: DEFAULT_SUGGESTIONS,
      companyIdFromUrl,
    };
  }

  return {
    pageContext: `Usuário na rota ${pathname}.`,
    suggestions: DEFAULT_SUGGESTIONS,
    companyIdFromUrl,
  };
}
